import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

interface CreateHolidayDialogProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (data: { date: Date; title: string; description: string }, shouldApply?: boolean) => void;
}

const CreateHolidayDialog: React.FC<CreateHolidayDialogProps> = ({
    open,
    onClose,
    onSubmit,
}) => {
    const [date, setDate] = useState<Date | null>(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    const handleSubmit = (shouldApply: boolean = false) => {
        if (date && title) {
            onSubmit({ date, title, description }, shouldApply);
            // Reset form
            setDate(null);
            setTitle("");
            setDescription("");
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Create New Holiday</DialogTitle>
            <DialogContent>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            label="Holiday Date"
                            value={date}
                            onChange={(newValue) => setDate(newValue)}
                            disablePast
                        />
                    </LocalizationProvider>
                    <TextField
                        label="Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                        fullWidth
                    />
                    <TextField
                        label="Description (Optional)"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        multiline
                        rows={3}
                        fullWidth
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    onClick={() => handleSubmit(false)}
                    variant="contained"
                    disabled={!date || !title}
                >
                    Create Draft
                </Button>
                <Button
                    onClick={() => handleSubmit(true)}
                    variant="contained"
                    color="secondary"
                    disabled={!date || !title}
                >
                    Create & Apply
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateHolidayDialog;
